import * as React from 'react';
import { Translate } from '../../../../../../../shared/LanguageService';

type ExternalProps = {
    receiverTranslationKey: string;
};

type InvoiceBrokerLabels = {
    receiver: string;
};

type InvoiceBrokerProps = {
    labels: InvoiceBrokerLabels;
    receiver: string;
};

export function InvoiceBroker({ labels, receiver }: InvoiceBrokerProps) {
    return (
        <dl>
            <dt>{labels.receiver}</dt>
            <dd>{receiver}</dd>
        </dl>
    );
}

export default function TranslatedInvoiceBroker({ receiverTranslationKey }: ExternalProps) {
    let labels: InvoiceBrokerLabels = {
        receiver: Translate('view-order/basic-order-info/invoice-info/receiver')
    };

    return <InvoiceBroker labels={labels} receiver={Translate(receiverTranslationKey)} />;
}
